import {
  GET_BUSINESS_COLOR_PALETTES,
  GET_BUSINESS_COLOR_PALETTES_SUCCESS,
  GET_PUBLIC_COLOR_PALETTES,
  GET_PUBLIC_COLOR_PALETTES_SUCCESS,
  GET_COLOR_PALETTE,
  GET_COLOR_PALETTE_SUCCESS,
  POST_COLOR_PALETTE,
  POST_COLOR_PALETTE_SUCCESS,
  RESET_POSTED_COLOR_PALETTE,
  PATCH_COLOR_PALETTE,
  DELETE_COLOR_PALETTE,
} from "Containers/ColorPalettes/types"

export const getBusinessColorPalettesAction = payload => ({
  type: GET_BUSINESS_COLOR_PALETTES,
  payload,
})
export const getBusinessColorPalettesSuccessAction = response => ({
  type: GET_BUSINESS_COLOR_PALETTES_SUCCESS,
  payload: response,
})
export const getPublicColorPalettesAction = payload => ({
  type: GET_PUBLIC_COLOR_PALETTES,
  payload,
})
export const getPublicColorPalettesSuccessAction = response => ({
  type: GET_PUBLIC_COLOR_PALETTES_SUCCESS,
  payload: response,
})
export const getSingleColorPaletteAction = payload => ({
  type: GET_COLOR_PALETTE,
  payload,
})
export const getSingleColorPaletteSuccessAction = response => ({
  type: GET_COLOR_PALETTE_SUCCESS,
  payload: response,
})
export const postColorPaletteAction = payload => ({
  type: POST_COLOR_PALETTE,
  payload,
})
export const postColorPaletteSuccessAction = response => ({
  type: POST_COLOR_PALETTE_SUCCESS,
  payload: response,
})
export const resetPostedColorPaletteAction = () =>({
  type: RESET_POSTED_COLOR_PALETTE,
})
export const patchColorPaletteAction = payload => ({
  type: PATCH_COLOR_PALETTE,
  payload,
})
export const deleteColorPaletteAction = payload => ({
  type: DELETE_COLOR_PALETTE,
  payload,
})